import { Fragment } from 'react';
import { ENERGIES, PERIODS, USAGES, fmt, ratioTotal } from './domain';
import { PC, UMR, caption } from './tokens';
import type { RatioTable as Ratios } from './types';

interface Props {
  value: Ratios;
  /** Nom de la station dont ces ratios sont déduits. */
  stationName: string;
}

const th = { padding: '6px', fontSize: 12, lineHeight: '16px', fontWeight: 700, color: UMR.textLabel, borderBottom: `1px solid ${UMR.border}` };
const td = { padding: '6px', fontSize: 13, textAlign: 'center' as const, fontVariantNumeric: 'tabular-nums' as const };

/** Ratios par défaut en lecture : une ligne par typologie × poste, une colonne par période. */
export function RatioReadTable({ value, stationName }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontFamily: UMR.font }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <strong style={{ fontSize: 14 }}>Ratios par défaut</strong>
        <span style={caption}>kWh/m²/an · calculés sur les degrés-jours de {stationName}</span>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
        <colgroup>
          <col style={{ width: 150 }} />
          <col style={{ width: 96 }} />
          {PERIODS.map((p) => <col key={p.key} />)}
        </colgroup>
        <thead>
          <tr style={{ background: UMR.grey100 }}>
            <th style={{ ...th, textAlign: 'left' }}>Typologie</th>
            <th style={{ ...th, textAlign: 'left' }}>Poste</th>
            {PERIODS.map((p) => <th key={p.key} style={{ ...th, textAlign: 'center' }}>{p.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {USAGES.map((u) => (
            <Fragment key={u.key}>
              {ENERGIES.map((e, i) => (
                <tr key={`${u.key}.${e.key}`} style={{ borderBottom: `1px solid ${UMR.borderSubtle}` }}>
                  {i === 0 && (
                    <td rowSpan={ENERGIES.length + 1} style={{ padding: 6, fontWeight: 700, fontSize: 13, verticalAlign: 'top', borderRight: `1px solid ${UMR.borderSubtle}` }}>
                      {u.label}
                    </td>
                  )}
                  <td style={{ padding: 6, fontSize: 13, color: UMR.textSecondary }}>{e.short}</td>
                  {PERIODS.map((p) => <td key={p.key} style={td}>{fmt(value[u.key][p.key][e.key])}</td>)}
                </tr>
              ))}
              <tr key={`${u.key}.total`} style={{ borderBottom: `1px solid ${UMR.border}`, background: PC.accentBg }}>
                <td style={{ padding: 6, fontSize: 12, fontWeight: 700, color: PC.accentStrong }}>Total</td>
                {PERIODS.map((p) => (
                  <td key={p.key} style={{ ...td, fontWeight: 700, color: PC.accentStrong }}>{fmt(ratioTotal(value[u.key][p.key]))}</td>
                ))}
              </tr>
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
